// extracted by mini-css-extract-plugin
module.exports = {"container":"BreadCrumb_container__3SHp_","breadcrumbItem":"BreadCrumb_breadcrumbItem__1gyD_","arrowIcon":"BreadCrumb_arrowIcon__1vXm-","rtl":"BreadCrumb_rtl__3FFnr"};